"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const pickers_1 = require("@material-ui/pickers");
const date_fns_1 = __importDefault(require("@date-io/date-fns"));
const keyPressHandler = (event, callback) => {
    if (event.key === 'Enter') {
        if (callback) {
            callback();
        }
    }
};
const DatePicker = ({ label, valor, onChange, enterHandler, maxDate, name, }) => {
    const [selectedDate, setSelectedDate] = react_1.useState(valor);
    react_1.useEffect(() => {
        if (selectedDate && selectedDate.getDate()) {
            onChange(selectedDate);
        }
        else {
            onChange(null);
        }
    }, [selectedDate, onChange]);
    return (react_1.default.createElement(pickers_1.MuiPickersUtilsProvider, { utils: date_fns_1.default },
        react_1.default.createElement(pickers_1.KeyboardDatePicker, { name: name, type: "tel", fullWidth: true, disableFuture: true, openTo: "year", format: "dd/MM/yyyy", views: ['year', 'month', 'date'], label: label, value: selectedDate, onChange: setSelectedDate, onKeyPress: e => keyPressHandler(e, enterHandler), maxDate: maxDate ? maxDate : '01/01/3000', invalidDateMessage: "Data inv\u00E1lida", maxDateMessage: "Data maior que o permitido" })));
};
exports.default = DatePicker;
//# sourceMappingURL=index.js.map